import { SET_PAYMENT_REPORT } from "../../assets/constants/reducer.type";

export const setPaymentReport = (payload) => {
  return { type: SET_PAYMENT_REPORT, payload };
};
